import type { NavItem } from '@/types'

export const mainNav: Array<NavItem> = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    {
        label: 'Services',
        href: '/services',
        children: [
            { label: 'All Services', href: '/services', description: "Sessions, pricing and common questions" },
            { label: 'Anxiety Therapy for Women', href: '/anxiety-therapy-olympia', description: "For racing thoughts and constant what-ifs" }
        ]
    },
    { label: 'Contact', href: '/contact' }
]

export const footerNav: Array<NavItem> = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Anxiety Therapy for Women', href: '/anxiety-therapy-olympia' },
    { label: 'Contact', href: '/contact' },
    { label: 'Privacy Policy', href: '/privacy-policy' }
]
